import { RestrictedModalTypesEnum } from '../const';

export const definedTranslation: Record<
  RestrictedModalTypesEnum,
  {
    reason: { id: string; defaultMessage: string };
    message: { id: string; defaultMessage: string };
  }
> = {
  [RestrictedModalTypesEnum.GEO]: {
    reason: {
      id: 'restricted-items-modal-geo-reason',
      defaultMessage:
        'This brand does not support specifications in your location',
    },
    message: {
      id: 'restricted-items-modal-geo-message',
      defaultMessage: "We've  found similar items available in your location!",
    },
  },
  [RestrictedModalTypesEnum.PROJECT]: {
    reason: {
      id: 'restricted-items-modal-project-reason',
      defaultMessage:
        'This brand does not support specifications for your project type.',
    },
    message: {
      id: 'restricted-items-modal-project-message',
      defaultMessage:
        "We've found similar items available for your project type!",
    },
  },

  [RestrictedModalTypesEnum.UNAVAILABLE]: {
    reason: {
      id: 'restricted-items-modal-unavailable-reason',
      defaultMessage:
        'This item is out of stock on Material Bank as well as from the brand',
    },
    message: {
      id: 'restricted-items-modal-unavailable-message',
      defaultMessage: "We've found similar items currently available!",
    },
  },
};
